// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ar from './locales/ar/translation.json';
import en from './locales/en/translation.json';
import tr from './locales/tr/translation.json';
import az from './locales/az/translation.json';
import es from './locales/es/translation.json';
import fr from './locales/fr/translation.json';
import kk from './locales/kk/translation.json';
import ky from './locales/ky/translation.json';
import ru from './locales/ru/translation.json';
import uz from './locales/uz/translation.json';

// vs. hepsi için aynı şekilde

i18n
  .use(LanguageDetector)      // tarayıcı dilini otomatik algılar
  .use(initReactI18next)
  .init({
    resources: {
        en: { translation: en },
        tr: { translation: tr },
        az: { translation: az },
        es: { translation: es },
        fr: { translation: fr },
        kk: { translation: kk },
        ky: { translation: ky },
        ru: { translation: ru },
        uz: { translation: uz },
        ar: { translation: ar },
      },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
